import Vue from 'vue';
import { getEventActivity, getStoreTimeList, sendEventActivity, getEventActivityList, cancelEventActivity, getEventActivityEditData, updateEventActivity } from '../../../services/eventActivityService/memberService';
import { checkMemberBind } from '../../../services/crmService/signUpService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  eventActivity: null,
  pagination: {
    current_page: 0,
    per_page: 10
  },
  storeTimeList:[],
  eventActivityList:[],
  editData: {},
  userInfo: null
};

// getters
const getters = {};

// actions
const actions = {
  // 取得event 活動資訊
  async getEventActivityHandler({ commit}, id) {
    const data = await getEventActivity(id);
    commit('setEventActivtiyData', data.data);
  },
  // 取得event 紀錄
  async getEventActivityListHandler({ commit}, id) {
    const data = await getEventActivityList(id);
    commit('setEventActivityList', data);
  },
  // 取得店舖時段
  async getStoreTimeListHandler({ commit}, id) {
    const data = await getStoreTimeList(id);
    commit('setStoreTimeList', data.data);
  },
  // 送出活動預約
  async sendEventActivityHandler({ commit}, formData) {
    return await sendEventActivity(formData);
  },
  // 取消預約
  async cancelEventActivityHandler({ commit }, formData) {
    return await cancelEventActivity(formData);
  },
  // 取得編輯預約資料
  async getEventActivityEditDataHandler({ commit }, formData) {
    const data = await getEventActivityEditData(formData);
    commit('setEditData', data.data);
  },
  // 編輯預約資料
  async updateEventActivityHandler({ commit }, formData) {
    return await updateEventActivity(formData);
  },
  // 編輯預約資料
  async checkBindingHandler({ commit }, formData) {
    return await checkMemberBind(formData);
  },
};

// mutations
const mutations = {
  setEventActivtiyData(state, data) {
    Vue.set(state, 'eventActivity', data);
  },
  setStoreTimeList(state, data) {
    Vue.set(state, 'storeTimeList', data);
  },
  setEventActivityList(state, data) {
    Vue.set(state, 'eventActivityList', data.data);
    Vue.set(state, 'pagination', data.pagination);
  },
  resetEventActivityList(state) {
    Vue.set(state, 'eventActivityList', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 10
    });
  },
  removeEventActivity(state, index) {
    state.eventActivityList.splice(index, 1);
    Vue.set(state.pagination, 'total', state.pagination.total - 1);
  },
  updateEventActivity(state, { index, status }) {
    Vue.set(state.eventActivityList[index], 'status', status);
  },
  setEditData(state, data) {
    Vue.set(state, 'editData', data);
  },
  setUserInfo(state, data) {
    Vue.set(state, 'userInfo', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
